import Injector from 'vue-inject';
import Debug from '@/util/debug';
import { PHP_CONFIG_PATH } from '@/util/constants';

const debug = Debug('service:Initializer');

const staticConfig = () => Promise.resolve({
  current_domain: window.location.host,
  FAM_API_URL: process.env.API_URL,
});

const urlConfig = () => fetch(PHP_CONFIG_PATH).then(res => res.json());

export default class Initializer {
  constructor(adApiUrlService) {
    this.adApiUrlService = adApiUrlService;
  }

  configure() {
    return (process.env.FETCH_CONFIG ? urlConfig() : staticConfig())
      .then(config => {
        debug.info('config (%s): %o', process.env.WITH_PHP ? 'php' : 'static', config);
        return config;
      })
      .then(config => {
        if (config.FAM_API_URL) {
          return this.adApiUrlService.setUrl(config.FAM_API_URL).catch(e => debug.warn('ignored:', e));
        }

        throw new Error('config did not have FAM_API_URL key');
      })
      .then(() => debug.info('configuration applied'))
      .catch(err => {
        debug.error('Error: %o', err);
        throw err;
      });
  }
}

Injector.service('initializerService', ['adApiUrlService'], Initializer);



// WEBPACK FOOTER //
// ./src/services/InitializerService.js